/**
 * Filter tabs for the Rehab page (All / Not Started / In Progress /
 * Completed). Mirrors the design's `filter-bar`.
 */
import { cn } from "@/lib/utils";

import type { RehabStatus } from "./rehab-status";

export type RehabFilter = RehabStatus | "all";

interface RehabFilterTabsProps {
  current: RehabFilter;
  onChange: (next: RehabFilter) => void;
  counts: Record<RehabFilter, number>;
}

const TABS: Array<{ value: RehabFilter; label: string }> = [
  { value: "all", label: "All" },
  { value: "not_started", label: "Not Started" },
  { value: "in_progress", label: "In Progress" },
  { value: "completed", label: "Completed" },
];

export function RehabFilterTabs({
  current,
  onChange,
  counts,
}: RehabFilterTabsProps) {
  return (
    <div
      className="inline-flex items-center gap-1 rounded-lg border border-border bg-card p-1.5"
      role="tablist"
      aria-label="Filter rehab projects by status"
    >
      {TABS.map((tab) => {
        const active = tab.value === current;
        return (
          <button
            key={tab.value}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(tab.value)}
            className={cn(
              "inline-flex items-center gap-2 rounded-md px-3.5 py-2 text-xs font-semibold transition",
              active
                ? "bg-primary text-primary-foreground"
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            {tab.label}
            <span
              className={cn(
                "rounded-full px-1.5 py-0.5 text-[10px] font-bold",
                active
                  ? "bg-primary-foreground/20"
                  : "bg-muted text-muted-foreground",
              )}
            >
              {counts[tab.value]}
            </span>
          </button>
        );
      })}
    </div>
  );
}
